import React from 'react';
import './StatusFilterCardProps.scss';
import { Card, Statistic } from 'antd';
import { AppliedFilter, filtersKeys } from 'types/types';
import { JobStatus } from 'components/StatusTag/StatusTag';

interface StatusFilterCardProps {
  jobStatusFilters: JobStatus[];
  setJobStatusFilters: React.Dispatch<React.SetStateAction<JobStatus[]>>;
  statusUnfilteredCounts: number;
  isStatusCountsLoading: boolean;
  setCurrentAppliedFilters: React.Dispatch<React.SetStateAction<AppliedFilter>>;
  title: string | React.ReactNode;
  JobStatusType: JobStatus;
  JobStatusClass: string;
}

const StatusFilterCard = ({
  jobStatusFilters,
  setJobStatusFilters,
  statusUnfilteredCounts,
  isStatusCountsLoading,
  setCurrentAppliedFilters,
  title,
  JobStatusType,
  JobStatusClass,
}: StatusFilterCardProps) => {
  const isSelected = jobStatusFilters.includes(JobStatusType);

  const toggleStatus = () => {
    const updatedStatuses: JobStatus[] = isSelected
      ? jobStatusFilters.filter((status) => status !== JobStatusType)
      : [...jobStatusFilters, JobStatusType];

    setJobStatusFilters(updatedStatuses);

    setCurrentAppliedFilters((appliedFilters) => {
      const filtersOtherThanStatus: AppliedFilter = Object.fromEntries(
        Object.entries(appliedFilters).filter(
          ([filterKey]) => filterKey !== filtersKeys.STATUS
        )
      ) as AppliedFilter;

      return {
        ...filtersOtherThanStatus,
        ...(updatedStatuses.length
          ? { [filtersKeys.STATUS]: updatedStatuses }
          : {}),
      };
    });
  };
  return (
    <Card
      className={
        isSelected
          ? `status-card__wrapper status-card__wrapper--selected status-card__wrapper${JobStatusClass}`
          : `status-card__wrapper status-card__wrapper${JobStatusClass}`
      }>
      <div className="status-card__button" onClick={toggleStatus}>
        <Statistic
          title={title}
          value={statusUnfilteredCounts}
          loading={isStatusCountsLoading}
        />
      </div>
    </Card>
  );
};

export default StatusFilterCard;
